import {Country} from "@pg-rp/common-types";

import {OFFER_GENERATED_DESCRIPTION_COMMERCIAL_CONTENT} from "../../constants/offer_generated_description_commercial_content";
import {IOffer} from "../../types/property/IOffer";
import {getParkingPlacesType} from "../../types/property/IParkingPlace";
import {VendorType} from "../../types/property/IVendor";
import {OfferGeneratedDescriptionTextCommercials} from "./OfferGeneratedDescriptionTextCommercials";

interface IProps {
    country: Country;
    offer: IOffer;
}

export const OfferGeneratedDescriptionCommercial = (props: IProps) => {
    const {country, offer} = props;
    const {DEFAULT_DEVELOPER_LABEL, getNoParkingPlacesText, getParkingPlacesHeader} = OFFER_GENERATED_DESCRIPTION_COMMERCIAL_CONTENT;

    const hasParkingPlaces = offer.parking_places?.length > 0;
    const isDeveloper = offer.vendor.type === VendorType.DEVELOPER;
    const investorOrVendorName = isDeveloper ? offer.investor || offer.vendor.name : DEFAULT_DEVELOPER_LABEL;

    return (
        <>
            <OfferGeneratedDescriptionTextCommercials country={country} offer={offer} />

            {hasParkingPlaces ? (
                <>
                    <p>{getParkingPlacesHeader(investorOrVendorName)}</p>

                    <ul>
                        {offer.parking_places.map((parkingPlace) => (
                            <li key={parkingPlace.id}>{getParkingPlacesType(parkingPlace.type).toLowerCase()}</li>
                        ))}
                    </ul>
                </>
            ) : (
                <p>{getNoParkingPlacesText(investorOrVendorName)}</p>
            )}
        </>
    );
};
import {Country} from "@pg-rp/common-types";

import {OFFER_GENERATED_DESCRIPTION_COMMERCIAL_CONTENT} from "../../constants/offer_generated_description_commercial_content";
import {IOffer} from "../../types/property/IOffer";
import {getParkingPlacesType} from "../../types/property/IParkingPlace";
import {VendorType} from "../../types/property/IVendor";
import {OfferGeneratedDescriptionTextCommercials} from "./OfferGeneratedDescriptionTextCommercials";

interface IProps {
    country: Country;
    offer: IOffer;
}

export const OfferGeneratedDescriptionCommercial = (props: IProps) => {
    const {country, offer} = props;
    const {DEFAULT_DEVELOPER_LABEL, getNoParkingPlacesText, getParkingPlacesHeader} = OFFER_GENERATED_DESCRIPTION_COMMERCIAL_CONTENT;

    const hasParkingPlaces = offer.parking_places?.length > 0;
    const isDeveloper = offer.vendor.type === VendorType.DEVELOPER;
    const investorOrVendorName = isDeveloper ? offer.investor || offer.vendor.name : DEFAULT_DEVELOPER_LABEL;

    return (
        <>
            <OfferGeneratedDescriptionTextCommercials country={country} offer={offer} />

            {hasParkingPlaces ? (
                <>
                    <p>{getParkingPlacesHeader(investorOrVendorName)}</p>

                    <ul>
                        {offer.parking_places.map((parkingPlace) => (
                            <li key={parkingPlace.id}>{getParkingPlacesType(parkingPlace.type).toLowerCase()}</li>
                        ))}
                    </ul>
                </>
            ) : (
                <p>{getNoParkingPlacesText(investorOrVendorName)}</p>
            )}
        </>
    );
};
